import { GetPortfolioChart, GetPortfolioChartForm, GetPortfolioInvestmentForm, GetPortfolioInvestmentList, GetPortfolioTradeAvgForCoin, GetPortfolioTradeAvgForCoinForm, GetPortfolioTradeAvgForCoinList, GetPortfolioTradeAvgForm, GetPortfolioTradeAvgList } from "./api";

import http from "config/http";

const portfolioApi = {
  getPortfolioChartForm: async () =>
    await http.get(GetPortfolioChartForm),

  getPortfolioChart: async ({ portfolioId, basketId }) =>
    await http.get(GetPortfolioChart({ portfolioId, basketId })),

  getPortfolioTradeAvgForm: async () =>
    await http.get(GetPortfolioTradeAvgForm),

  getPortfolioInvestmentForm: async () =>
    await http.get(GetPortfolioInvestmentForm),

  getPortfolioTradeAvgList: async ({ portfolioId, basketId, dateTypeId, startDate }) =>
    await http.get(GetPortfolioTradeAvgList({ portfolioId, basketId, dateTypeId, startDate })),

  getPortfolioInvestmentList: async ({ portfolioId, basketId, dateTypeId, startDate }) =>
    await http.get(GetPortfolioInvestmentList({ portfolioId, basketId, dateTypeId, startDate })),

  getPortfolioTradeAvgForCoinForm: async ({ portfolioId, basketId, dateTypeId, startDate, coinId }) =>
    await http.get(GetPortfolioTradeAvgForCoinForm({ portfolioId, basketId, dateTypeId, startDate, coinId })),

  getPortfolioTradeAvgForCoin: async ({ portfolioId, basketId, dateTypeId, startDate, coinId }) =>
    await http.get(GetPortfolioTradeAvgForCoin({ portfolioId, basketId, dateTypeId, startDate, coinId })),

  getPortfolioTradeAvgForCoinList: async ({ portfolioId, basketId, dateTypeId, startDate, coinId, pageNumber, pageSize }) =>
    await http.get(GetPortfolioTradeAvgForCoinList({ portfolioId, basketId, dateTypeId, startDate, coinId, pageNumber, pageSize })),
};

export default portfolioApi;
